import { addDays, Duration, format, sub } from "date-fns";

import { DATE_FORMATS, MONTHS } from "@tm/isomorphic-utils";

// CALENDAR UTILITY FUNCTIONS
export const randomDayData = () => {
  const min = 10000;
  const max = 15000;
  const randomNum = Math.floor(Math.random() * (max - min + 1) + min);

  return {
    price: `₹${randomNum}`,
    class: randomNum <= 12000 ? "greenText" : "redText",
    isSoldOut: randomNum > 12000 && randomNum < 13000,
    availableOnPreviousDate: randomNum >= 13000 && randomNum <= 13500,
  };
};

export const convertUnixToDate = (unix?: number | null) => {
  if (unix) {
    return new Date(unix * 1000);
  }
  return;
};

export const convertDateToUnix = (date: Date) => {
  return Math.floor(new Date(date).getTime() / 1000);
};

export const formatDate = (date: Date | string, dateFormat: DATE_FORMATS) => {
  if (date) {
    try {
      date = new Date(date);
      return format(date, dateFormat);
    } catch (error) {
      /* istanbul ignore next */
      console.log("Error in formatting given date", `${date} | ${dateFormat}`);
    }
  }
  return "";
};

export const addDaysToDate = (date: Date, days = 1) => {
  try {
    return addDays(date, days);
  } catch (error) {
    /* istanbul ignore next */
    console.log("Error in adding given days to date", `${date} | ${days}`);
  }
  /* istanbul ignore next */
  return;
};

export const subtractDurationFromDate = (
  date: Date | string,
  duration: Duration
) => {
  if (date) {
    try {
      date = new Date(date);
      return sub(date, duration);
    } catch (error) {
      /* istanbul ignore next */
      console.log(
        "Error in subtracting given duration from date",
        `${date} | ${duration}`
      );
    }
  }
  /* istanbul ignore next */
  return new Date();
};

export const subtractYrsFromDate = (date: Date | string, years: number) => {
  if (date && years) {
    try {
      return subtractDurationFromDate(date, { years });
    } catch (error) {
      /* istanbul ignore next */
      console.log(
        "Error in subtracting given years from date",
        `${date} | ${years}`
      );
    }
  }
  /* istanbul ignore next */
  return new Date();
};

export const calendarLabelFormatter = (dateObj: any) => {
  return dateObj
    ? `${dateObj.getDate()} ${MONTHS[dateObj.getMonth()]}' ${dateObj
        .getFullYear()
        .toString()
        .slice(-2)}`
    : `${new Date().getDate()} ${MONTHS[new Date().getMonth()]}' ${new Date()
        .getFullYear()
        .toString()
        .slice(-2)}`;
};
